var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen"},[_c('ElevateSearchController',_vm._b({attrs:{"search-query":_vm.searchQuery,"page-size":_vm.limit}},'ElevateSearchController',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }